(function (ebusy, $) {

	ebusy.messages = ebusy.messages || {};

	ebusy.messages.replacePlaceholders = function(message, values) {

		result = message;

		for (var i = 0; i < values.length; i++) {
			result = result.replace("{" + i + "}", values[i]);
		}

		return result;
	}

})(window.ebusy = window.ebusy || {}, window.jQuery);
